"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var utilities_1 = require("./utilities");
function initialize() {
    utilities_1.initializeCulture(__CULTURE__);
    exports.Culture = __CULTURE__;
}
exports.initialize = initialize;
;
function loadGlobalizationScript(context, loader) {
    if (context === void 0) { context = window.csod.context; }
    if (loader === void 0) { loader = window.csod.utils.loadScript; }
    var sourceUrl = context.playerBase + globalizationPath(context.cultureName || '');
    return loader(sourceUrl)
        .then(initialize, function () {
        throw new Error('Unable to load globalization values');
    });
}
exports.loadGlobalizationScript = loadGlobalizationScript;
if (typeof __CULTURE__ !== 'undefined') {
    initialize();
}
else if (window.csod && window.csod._services && !window.csod._services.disableAutoGlobalization) {
    if (window.csod.context && window.csod.context.playerBase) {
        loadGlobalizationScript();
    }
    else {
        throw new Error('Unable to locate globalization data source');
    }
}
//# sourceMappingURL=main.js.map
function globalizationPath(locale){ return 'player-globalization/1.1/' + locale + '.js';};


//////////////////
// WEBPACK FOOTER
// ../player-globalization/main.js
// module id = 176
// module chunks = 0 1